import React from "react";
import fisioterapiaImage from '../../assets/images/servicos/fisioterapia.jpg';

const Fisioterapia = () => {
    return (
        <>
            <section className="breadcrumb-section">
                <div className="container">
                    <h1>Fisioterapia</h1>
                    <div className="breadcrumb">
                        <a href="/home">Home</a>
                        <span className="fa fa-angle-double-right"></span>
                        <span className="current">Fisioterapia</span>
                    </div>
                </div>
            </section>

            <div id="main">
                <div className="container">
                    <section id="primary" className="with-sidebar">
                        <article className="blog-entry">
                            <div className="blog-entry-inner">
                                <div className="entry-thumb">
                                    <img src={fisioterapiaImage} alt="Fisioterapia" />
                                </div>
                                <div className="entry-details">
                                    <div className="entry-title">
                                        <h3> Qual a importância da fisioterapia na infância? </h3>
                                    </div><br />
                                    <div className="entry-body">
                                        <p>A fisioterapia focada na infância tem por objetivo melhorar o bem estar físico da criança.<br /><br />É uma especialidade voltada para a avaliação, prevenção e tratamento de alterações no desenvolvimento motor de bebês, crianças e adolescentes. <br /><br />Seu objetivo principal é promover o desenvolvimento saudável, melhorar a funcionalidade, prevenir complicações e habilitar ou reabilitar habilidades motoras comprometidas.<br /><br />
                                        A abordagem é lúdica, adaptada à idade da criança e integrada ao contexto familiar, promovendo uma experiência acolhedora e eficaz.</p>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </section>

                    <section id="secondary">
                        <aside className="widget widget_text">
                            <h3 className="widgettitle">Nossos serviços incluem</h3>
                            <p>Desenvolver as habilidades motoras das crianças.</p><br />
                            <p>Tratar patologias que afetam o sistema musculoesquelético, neurológico e respiratório.</p><br />
                            <p>Prevenir complicações futuras e melhorar a qualidade de vida a longo prazo.</p><br />
                            <p><b>Alguns exemplos de intervenção são:</b><br /> torcicolo congênito, correção nos pézinhos, fortalecimento muscular, atrasos de desenvolvimento motor (engatinhar, andar, rolar).</p><br />
                        </aside>
                    </section>
                </div>
            </div>
        </>
    );
};

export default Fisioterapia;
